import { Component } from '@angular/core';
import { ViewController, ModalController, AlertController, IonicPage, NavController, NavParams, ToastController } from 'ionic-angular';
/**
 * Generated class for the MymodalComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'mymodal',
  templateUrl: 'mymodal.html'
})
export class MymodalComponent {

  text: string;
  img_src: string;
  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController) {
    // debugger
    //console.log('UserId', navParams.get('img_url'));
    this.img_src = navParams.get('img_url');
  }

  closeModal() {
    // let data = { 'foo': 'bar' };
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/components/mymodal/mymodal.ts